module.exports = __webpack_public_path__ + "img/detail-time.ef125bfb.svg";